export default {
  children: [
    {
      path: 'home',
      name: 'awards-home',
      component: () => import(
        /* webpackChunkName: "awards-home" */
        '@/awards/pages/home/AwardsHomePage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: 'awardshome',
      },
    },
    {
      path: 'results',
      name: 'awardresults',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/results/ResultsPage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: '',
        pageTitle: 'Award Results',
      },
      redirect: { name: 'awardsregionalview' },
      children: [
        {
          path: 'regional-view',
          name: 'awardsregionalview',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/RegionalResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Regional View',
            resultType: 'region',
          },
        },
        {
          path: 'office-view',
          name: 'awardsOfficeview',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/OfficeResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Office View',
            resultType: 'office',
          },
        },
        {
          path: 'category-view',
          name: 'awardscategoryview',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/CategoryResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Category View',
            resultType: 'category',
          },
        },
        {
          path: 'winners-list-view',
          name: 'awardswinnerslistview',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/WinnersListResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Winners List View',
            resultType: 'winner',
          },
        },
        {
          path: 'winners-with-points-view',
          name: 'awardswinnerswithpointslistview',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/WinnersWithPointsResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Winners With Points List View',
            resultType: 'winnerWithPoints',
          },
        },
      ],
    },
    {
      path: 'results-v2',
      name: 'metadataawardresults',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/results/MetadataAwardResultsPage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: '',
        pageTitle: 'Award Results',
      },
      redirect: { name: 'regionalawardresults' },
      children: [
        {
          path: 'region',
          name: 'regionalawardresults',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/RegionalResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Regional View',
            resultType: 'region',
            isRevamped: true,
          },
        },
        {
          path: 'office',
          name: 'officeawardresults',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/OfficeResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Office View',
            resultType: 'office',
            isRevamped: true,
          },
        },
        {
          path: 'category',
          name: 'categoryawardresults',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/CategoryResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Category View',
            resultType: 'category',
            isRevamped: true,
          },
        },
        {
          path: 'winners',
          name: 'winnersawardresults',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/WinnersListResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Winners List View',
            resultType: 'winner',
            isRevamped: true,
          },
        },
        {
          path: 'winners-with-points',
          name: 'winnerswithpointsawardresults',
          component: () => import(
            /* webpackChunkName: "awardresults" */
            '@/awards/pages/results/WinnersWithPointsResultsPage.vue'
          ),
          meta: {
            requiresAuth: true,
            hideSearchFromHeader: false,
            showRightPanel: false,
            showFilters: false,
            mobileName: '',
            pageTitle: 'Award Results - Winners With Points List View',
            resultType: 'winnerWithPoints',
            isRevamped: true,
          },
        },
      ],
    },
    {
      path: 'leaderboard',
      name: 'awardsleaderboards',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/leaderboard/LeaderBoardsPage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: '',
        pageTitle: 'Cadre Rankings',
      },
    },
    {
      path: 'leaderboard-v2',
      name: 'metadataleaderboardresults',
      component: () => import(
        '@/awards/pages/leaderboard/MetadataLeaderBoardsPage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: '',
        pageTitle: 'Cadre Rankings',
      },
    },
    {
      path: 'showcase',
      name: 'showcase',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/showcase/ShowcasePage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: 'showcase',
        pageTitle: 'Award Showcase',
      },
    },
    {
      path: 'leaderboardandresults',
      name: 'leaderboardandresults',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/leaderboard/LeaderBoardsPage.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: 'leaderboardandresults',
      },
    },
    {
      path: 'insights/cannes',
      name: 'awardInsights',
      component: () => import(
        /* webpackChunkName: "leaderboards" */
        '@/awards/pages/results/CannesAwardsInsights.vue'
      ),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
        showFilters: false,
        mobileName: 'cannesInsights',
        pageTitle: 'Cannes Lions Award Advance Analytics Performance Tracker Dashboard',
      },
    },
  ],
};
